import React, { useEffect, useState } from 'react'

export const ContextDashboard = React.createContext<any>({})


export default function ContextDashboardModels(props: any) {
    const [employees, setEmployees] = useState<any>([])
    const [location, setLocation] = useState<any>([])
    // همه اطلاعات ریکوست می را نگه میدارد
    const [profile, setProfile] = useState<any>(null)
    const [dashboard, setDashboard] = useState<any>(null)
    const [plan, setPlan] = useState<any>(null)




    return (
        <ContextDashboard.Provider value={{
            employees,
            setEmployees ,
            location , 
            setLocation ,
            plan ,
            setPlan ,
            profile , 
            setProfile ,
            dashboard ,
            setDashboard
        }}>
            {props.children}
        </ContextDashboard.Provider>
    )
}